import * as types from './mutation-types';
import * as globalTypes from '../../mutation-types';
import quoteApi from '../../../api/quote';
import apiVehicle from '../../../api/vehicle';
import wizardApi from '../../../api/wizard';
import restrictions from '../../../api/restrictions';
import quote from '../../../api/quote';
import router from '../../../router';
// import livevoxService from '../../../api/clients/livevoxService'
import zipCodeAPI from '../../../api/zipcode.js';
import { setErrorLog } from '../logger/actions.js';
import verintService from '../../../api/clients/verintService';
import { getOpenFollowupID } from '../../../utils/utils';
import config from '../../../config';

export const saveStep1 = async ({ dispatch, commit, state }) => {
  try {
    state.wizardData.quote.MarketID =
      state.wizardData.quote.MarketID > 0 ? state.wizardData.quote.MarketID : 1;
    state.wizardData.quote.QuoteOriginTypeID =
      state.wizardData.quote.QuoteOriginTypeID > 0
        ? state.wizardData.quote.QuoteOriginTypeID
        : 1;
    state.wizardData.quote.QuoteStatusTypeID =
      state.wizardData.quote.QuoteStatusTypeID > 0
        ? state.wizardData.quote.QuoteStatusTypeID
        : 1;
    var result = await wizardApi.saveStep1({
      Customer: state.wizardData.customer,
      Quote: state.wizardData.quote,
      CallInformation: state.wizardData.callInformation,
      QuoteThirdPartyPartner: state.wizardData.thirdParty,
    });
    commit(types.SET_SAVESTEP1_DATA, result.data);
  } catch (e) {
    commit(types.MOVE_WIZARD_BACK);
    commit(types.SET_SKIP_EXIT_CONFIRMATION, true);
    let msg = 'There was an error saving step 1 data.';
    dispatch('showError', msg, { root: true });
    throw msg;
  }
};

export const saveStep2 = async ({ dispatch, commit, state, rootState }) => {
  try {
    var results = (
      await zipCodeAPI.getApprovedZipCodes(
        state.wizardData.quotePickupLocation.ZipCode
      )
    ).data;
    state.wizardData.vehicle.HaulFee =
      results.towingFee + results.milesFromLocation;

    state.wizardData.vehicle.VehiclePriceAdjustment = state.wizardData.vehicle
      .VehiclePriceAdjustment
      ? parseInt(state.wizardData.vehicle.VehiclePriceAdjustment)
      : 0;
    var result = await wizardApi.saveStep2({
      Vehicle: state.wizardData.vehicle,
      ZipCode: state.wizardData.quotePickupLocation.ZipCode,
      StateID: state.wizardData.quotePickupLocation.StateID,
      UserID: rootState.login.userID,
      City: state.wizardData.quotePickupLocation.City,
    });
    commit(types.SET_SAVESTEP2_DATA, result.data);
  } catch (e) {
    commit(types.MOVE_WIZARD_BACK);
    commit(types.SET_SKIP_EXIT_CONFIRMATION, true);
    let msg = 'There was an error saving step 2 data.';
    dispatch('showError', msg, { root: true });
    throw msg;
  }
};

export const saveSellerPrice = async ({
  dispatch,
  commit,
  state,
  rootState,
}) => {
  try {
    var results = (
      await zipCodeAPI.getApprovedZipCodes(
        state.wizardData.quotePickupLocation.ZipCode
      )
    ).data;
    state.wizardData.vehicle.HaulFee =
      results.towingFee + results.milesFromLocation;
    await wizardApi.saveStep2({
      Vehicle: state.wizardData.vehicle,
      ZipCode: state.wizardData.quotePickupLocation.ZipCode,
      StateID: state.wizardData.quotePickupLocation.StateID,
      UserID: rootState.login.userID,
      City: state.wizardData.quotePickupLocation.City,
    });
  } catch (e) {
    commit(types.MOVE_WIZARD_BACK);
    commit(types.SET_SKIP_EXIT_CONFIRMATION, true);
    let msg = 'There was an error saving step 2 data.';
    dispatch('showError', msg, { root: true });
    throw msg;
  }
};

export const saveStep6 = async ({ dispatch, commit, state, rootState }) => {
  try {
    var result = await wizardApi.saveStep6({
      QuoteID: state.wizardData.quote.QuoteID,
      VehicleID: state.wizardData.vehicle.VehicleID,
      Operable: state.wizardData.vehicle.Operable,
      PickupLocationTypeID:
        state.wizardData.quotePickupLocation.PickupLocationTypeID,
    });
    if (!result.data) {
      throw null;
    }
  } catch (e) {
    commit(types.MOVE_WIZARD_BACK);
    commit(types.SET_SKIP_EXIT_CONFIRMATION, true);
    let msg = 'There was an error saving step 6 data.';
    dispatch('showError', msg, { root: true });
    return false;
  }
};

export const saveStep8 = async ({ dispatch, commit, state }) => {
  try {
    var result = await wizardApi.saveStep8({
      Quote: state.wizardData.quote,
      Vehicle: state.wizardData.vehicle,
    });
    commit(types.SET_LIEN, state.wizardData.vehicle.HasLien);
    commit(types.SET_SAVESTEP8_DATA, result.data);
  } catch (e) {
    commit(types.MOVE_WIZARD_BACK);
    commit(types.SET_SKIP_EXIT_CONFIRMATION, true);
    let msg = 'There was an error saving step 8 data.';
    dispatch('showError', msg, { root: true });
    throw msg;
  }
};

export const saveStep9 = async (
  { dispatch, commit, state },
  quotePickupLocation
) => {
  try {
    if (
      quotePickupLocation.QuoteID == null ||
      quotePickupLocation.QuoteID == 0
    ) {
      quotePickupLocation.QuoteID = state.wizardData.quote.QuoteID;
    }

    quotePickupLocation.PickupLocationTypeID =
      quotePickupLocation.PickupLocationTypeID > 0
        ? quotePickupLocation.PickupLocationTypeID
        : null;

    delete quotePickupLocation.Zipcode;
    delete quotePickupLocation.pickupLocationTypeID;
    var result = await wizardApi.saveStep9({
      QuotePickupLocation: quotePickupLocation,
      CustomerID: state.wizardData.customer.CustomerID,
      SecondaryPhone: state.wizardData.customer.SecondaryPhone,
    });
    if (!result.data) {
      throw null;
    }
    commit(types.SET_SAVESTEP9_DATA, result.data);
  } catch (e) {
    commit(types.MOVE_WIZARD_BACK);
    commit(types.SET_SKIP_EXIT_CONFIRMATION, true);
    let msg = 'There was an error saving step 9 data.';
    dispatch('showError', msg, { root: true });
    throw msg;
  }
};

export const saveFollowup = async ({ dispatch, commit }, followup) => {
  try {
    var result = await wizardApi.saveFollowup(followup);
    commit(types.SET_FOLLOWUP_QUOTE, result.data);
  } catch (e) {
    commit(types.MOVE_WIZARD_BACK);
    commit(types.SET_SKIP_EXIT_CONFIRMATION, true);
    let msg = 'There was an error saving Followup for Quote.';
    dispatch('showError', msg, { root: true });
    throw msg;
  }
};

export const updateFollowup = async ({ dispatch, commit }, followup) => {
  try {
    await wizardApi.updateFollowup(followup);
  } catch (e) {
    let msg = 'There was an error updating Followup for Quote.';
    dispatch('showError', msg, { root: true });
    throw msg;
  }
};

export const saveOffer = async ({ dispatch, commit }, offer) => {
  try {
    var result = await wizardApi.saveOffer(offer);
    commit(types.SET_ACCEPTED_QUOTE, result.data);
  } catch (e) {
    commit(types.MOVE_WIZARD_BACK);
    commit(types.SET_SKIP_EXIT_CONFIRMATION, true);
    let msg = 'There was an error saving Accepted Offer.';
    dispatch('showError', msg, { root: true });
    throw msg;
  }
};

export const createNewOffer = async ({
  dispatch,
  commit,
  state,
  rootState,
}) => {
  try {
    var newOffer = {
      vehicleID: state.wizardData.vehicle.VehicleID,
      zipCode: state.wizardData.quotePickupLocation.ZipCode,
      userID: rootState.login.userID,
    };
    var result = await wizardApi.createNewOffer(newOffer);
    commit(types.SET_SUGGESTED_OFFER, result.data);
  } catch (e) {
    let msg = 'There was an error creating New Offer.';
    dispatch('showError', msg, { root: true });
    throw msg;
  }
};

export const setQuotePickupLocation = async ({ dispatch, commit }, qpl) => {
  try {
    if (qpl.QuoteID == null || qpl.QuoteID == 0) {
      qpl.QuoteID = state.wizardData.quote.QuoteID;
    }
    var result = await wizardApi.setQuotePickupLocation(qpl);
    let data = {
      status: result.status,
      qplID: result.data,
      qpl: qpl,
    };
    commit(types.SET_QUOTE_PICKUP_LOCATION, data);
  } catch (e) {
    let msg = 'There was an error saving quote pickup location.';
    dispatch('showError', msg, { root: true });
    throw msg;
  }
};

export const setThirdParty = async ({ dispatch, commit }, thirdParty) => {
  try {
    var result = await wizardApi.setThirdParty(thirdParty);
    let data = {
      QuoteThirdPartyPartnerID: result.data,
      thirdParty: thirdParty,
    };

    if (result.status == 200) {
      commit(types.SET_THIRD_PARTY, data);
    }
  } catch (e) {
    let msg = 'There was an error saving quote pickup location.';
    dispatch('showError', msg, { root: true });
    throw msg;
  }
};

export const saveDisposition = async ({ dispatch, commit, state }) => {
  try {
    var result = await wizardApi.saveDisposition(state.wizardData.quote);
    commit(types.SET_QUOTE_STATUS, result.data);
  } catch (e) {
    commit(types.SET_SKIP_EXIT_CONFIRMATION, true);
    let msg = 'There was an error saving disposition.';
    dispatch('showError', msg, { root: true });
    router.push('/');
    //throw msg;
  }
};

export const wizardSaveDisposition = async ({ dispatch, commit, state }) => {
  try {
    var result = await wizardApi.saveDisposition(state.wizardData.quote);
    if (result.data) {
      commit(types.SET_QUOTE_STATUS, result.data);
    } else {
      commit(types.MOVE_WIZARD_BACK);
      commit(types.SET_SKIP_EXIT_CONFIRMATION, true);
      let msg = 'There was an error saving disposition.';
      dispatch('showError', msg, { root: true });
    }
  } catch (e) {
    commit(types.MOVE_WIZARD_BACK);
    commit(types.SET_SKIP_EXIT_CONFIRMATION, true);
    let msg = 'There was an error saving disposition.';
    dispatch('showError', msg, { root: true });
  }
};

export const sendEmail = async ({ dispatch }, quoteID) => {
  try {
    var result = await wizardApi.sendEmail(quoteID);
    let msg = 'Quote confirmation email send was a ' + result.data + '.';
    dispatch('showNotification', msg, { root: true });
  } catch (e) {
    commit(types.MOVE_WIZARD_BACK);
    commit(types.SET_SKIP_EXIT_CONFIRMATION, true);
    let msg = 'There was an error sending quote confirmation email.';
    dispatch('showError', msg, { root: true });
    throw msg;
  }
};

export const sendUPAPHaulerEmail = async ({ dispatch }, quoteID) => {
  try {
    var result = await wizardApi.sendUPAPHaulerEmail(quoteID);
    if (result.data.startsWith('No Dispatch Email Specified For ')) {
      return;
    }
    let msg = 'Pickup email send was a ' + result.data + '.';
    dispatch('showNotification', msg, { root: true });
  } catch (e) {}
};

export const sendToDispatch = async ({ dispatch, commit }, id) => {
  try {
    var result = await quoteApi.sendToDispatch(id);
    if (result.data.status === 500) {
      throw new Error(result.data.statusText);
    }
    const remoteQuoteID = result.data && result.data != null ? result.data : {};
    commit(types.SET_REMOTE_QUOTE_ID, remoteQuoteID);
  } catch (e) {
    commit(types.MOVE_WIZARD_BACK);
    commit(types.SET_SKIP_EXIT_CONFIRMATION, true);
    let msg = 'There was an error sending Quote ID: ' + id + ' to DCB.';
    dispatch('showError', msg, { root: true });
    throw msg;
  }
};

export const verifyComplete = async ({ dispatch, commit }, id) => {
  try {
    var result = await quoteApi.verifyComplete(id);
    if (result.data.success === false) {
      throw new Error(result.data.message);
    }
    commit(types.SET_VERIFIED_QUOTE, true);
  } catch (e) {
    let msg = e;
    dispatch('showError', msg, { root: true });
    commit(types.SET_VERIFIED_QUOTE, false);
  }
  // quoteApi.verifyComplete(id).then(response => {
  //     if(response.data.success == false){
  //        const error = {
  //          title: 'Error',
  //          message: response.data.message,
  //          type: 'error'
  //        }
  //      commit(globalTypes.NOTIFY_ERRORS, error)
  //       return;
  //  }
  //  })
  //  .catch(err => {
  //   console.log(err)
  //    const error = {
  //     title: 'Error',
  //    message: err.message,
  //     type: 'error'
  //    }
  //   commit(globalTypes.NOTIFY_ERRORS, error)
  // });
};

export const getQuoteById = async ({ dispatch, commit, state }, id) => {
  try {
    var result = await quoteApi.getQuoteById(id);
    var quote = result.data && result.data != null ? result.data : {};
    if (result.data.status === 400) {
      throw new Error(result.data.statusText);
    }
    if (result.data == '') {
      quote = {
        ...state.wizardData.quote,
        quoteStatusTypeID: -1,
      };
    }
    commit(types.SET_SELECTED_QUOTE, quote);
  } catch (e) {
    let msg = 'There was an error getting Quote ID: ' + id + '.';
    dispatch('showError', msg, { root: true });
  }
};

export const getAdminQuoteById = async ({ dispatch, commit }, id) => {
  try {
    var result = await quoteApi.getAdminQuoteById(id);
    const quote = result.data && result.data != null ? result.data : {};
    commit(types.SET_SELECTED_QUOTE_ADMIN, quote);
  } catch (e) {
    let msg = 'There was an error getting Quote ID: ' + id + '.';
    dispatch('showError', msg, { root: true });
    throw msg;
  }
};

export const getFollowUpQuotes = async ({ dispatch, commit }) => {
  try {
    var result = await quoteApi.getFollowUpQuotes();
    let resultFilter = result.data.filter(function (fu) {
      return fu.quoteStatusType != 'Web Quote Entered';
    });
    commit(types.SET_QUOTE_LIST, resultFilter);
  } catch (e) {
    let msg = 'There was an error getting Follow Up Quotes';
    dispatch('showError', msg, { root: true });
    throw msg;
  }
};

export const getFollowUpQuotesAdmin = async ({ dispatch, commit }) => {
  try {
    var result = await quoteApi.getFollowUpQuotesAdmin();
    let resultFilter = result.data.filter(function (fu) {
      return fu.quoteStatusType != 'Web Quote Entered';
    });
    commit(types.SET_QUOTE_LIST, resultFilter);
  } catch (e) {
    let msg = 'There was an error getting Follow Up Quotes';
    dispatch('showError', msg, { root: true });
    throw msg;
  }
};

export const getWebQuoteQueue = async ({ dispatch, commit }) => {
  try {
    var result = await quoteApi.getWebQuoteQueue();
    commit(types.SET_WEB_QUOTE_QUEUE, result.data);
  } catch (e) {
    let msg = 'There was an error getting the Web Quote queue';
    dispatch('showError', msg, { root: true });
    throw msg;
  }
};

export const setCurrentWizardStep = async (
  { dispatch, commit, state },
  stepValue
) => {
  commit(types.SET_CURRENT_WIZARD_STEP, stepValue);
  if (state.wizardData.quote.QuoteID) {
    try {
      var wizardStepProgress = {
        wizardStepProgressID: 0,
        quoteID: state.wizardData.quote.QuoteID,
        wizardStepStack: state.wizardData.wizardStepStack.join(','),
      };
      var result = await wizardApi.saveStepProgress(wizardStepProgress);
      if (!result) {
        let msg = 'Step progress could not be saved.';
        dispatch('showError', msg, { root: true });
      }
    } catch (e) {
      let msg = 'There was an error saving step progress.';
      dispatch('showError', msg, { root: true });
      throw msg;
    }
  }
};

export const moveWizardBack = async ({ dispatch, commit, state }) => {
  commit(types.MOVE_WIZARD_BACK);

  if (state.wizardData.quote.QuoteID) {
    try {
      var wizardStepProgress = {
        wizardStepProgressID: 0,
        quoteID: state.wizardData.quote.QuoteID,
        wizardStepStack: state.wizardData.wizardStepStack.join(','),
      };
      var result = await wizardApi.saveStepProgress(wizardStepProgress);
      if (!result) {
        let msg = 'Step progress could not be saved.';
        dispatch('showError', msg, { root: true });
      }
    } catch (e) {
      let msg = 'There was an error saving step progress.';
      dispatch('showError', msg, { root: true });
      throw msg;
    }
  }
};

export const updateVehicle = async ({ dispatch, state }) => {
  try {
    await wizardApi.updateVehicle(state.wizardData.vehicle);
  } catch (e) {
    let msg = 'There was an error updating Vehicle for Quote.';
    dispatch('showError', msg, { root: true });
    throw msg;
  }
};

export const setNextDisabled = ({ commit }, disabled) => {
  commit(types.SET_NEXT_DISABLED, disabled);
};

export const setBackDisabled = ({ commit }, disabled) => {
  commit(types.SET_BACK_DISABLED, disabled);
};

export const setCurrentStep = ({ commit }, stepValue) => {
  commit(types.SET_CURRENT_STEP, stepValue);
  commit(types.SET_QUOTE_LAST_CURRENT_STEP, stepValue);
};

export const setFlowCurrentStep = ({ commit }, stepdata) => {
  commit(types.SET_FLOW_CURRENT_STEP, stepdata);
};

export const setSelectedQuote = ({ commit }, quote_number) => {
  commit(types.SET_SELECTED_QUOTE, quote_number);
};

export const setSelectedQuoteAdmin = ({ commit }, quote_number) => {
  commit(types.SET_SELECTED_QUOTE_ADMIN, quote_number);
};

export const getVehiculeModelByMakeAndYear = ({ commit }, values) => {
  commit(globalTypes.LOADING_START, 'Loading Models...');
  apiVehicle.getModels(values).then(function (response) {
    if (response.status !== 200) {
      var error = {
        title: 'Loading model Failed',
        message: 'Please contact support',
        type: 'error',
      };

      commit(globalTypes.NOTIFY_ERRORS, error);
    } else {
      if (response.data.Message === 'Execution Error') {
        var error = {
          title: 'Failed',
          message: response.data.Results[0].Message,
          type: 'error',
        };

        commit(globalTypes.NOTIFY_ERRORS, error);
      } else {
        console.log(response);
        commit(types.LOAD_MODELS_BY_MAKE_AND_YEAR, response.data.Results);
        commit(globalTypes.LOADED_SUCCESS);
      }
    }
  });
};

export const checkVIN = async ({ commit }, values) => {
  commit(globalTypes.LOADING_START, 'Validating VIN information...');
  await apiVehicle
    .checkVIN(values)
    .then(function (response) {
      if (response.data.length == 0) {
        // var error = {
        //   title: 'Failed',
        //   message: 'No information found',
        //   type: 'error'
        // }
        // commit(globalTypes.NOTIFY_ERRORS, error)
        commit(globalTypes.LOADED_SUCCESS);
      } else {
        if (response.data.Message === 'Execution Error') {
          var error = {
            title: 'Failed',
            message: response.data.Results[0].Message,
            type: 'error',
          };
          commit(globalTypes.NOTIFY_ERRORS, error);
        } else {
          commit(types.CHECK_VIN_INFORMATION, response.data);
          commit(globalTypes.LOADED_SUCCESS);
        }
      }
    })
    .catch((err) => {
      const error = {
        title: 'Error',
        message: 'VIN error',
        type: 'error',
      };
      commit(globalTypes.NOTIFY_ERRORS, error);
      commit(globalTypes.LOADED_SUCCESS);
    });
};

export const resetWizard = ({ commit, state, rootState }) => {
  commit(types.RESET_WIZARD);
};
export const resetWizardStartStep = (
  { commit, state, rootState },
  customer
) => {
  commit(types.RESET_WIZARD, customer);
};
//third party
export const declineInitialQuote = ({ commit }, offer) => {
  commit(types.DECLINE_INITIAL_QUOTE, offer);
};
export const unsetDeclineInitialQuote = ({ commit }) => {
  commit(types.UNSET_DECLINE_INITIAL_QUOTE);
};
export const doubleDeclineQuote = ({ commit }) => {
  commit(types.DOBULE_DECLINE_INITIAL_QUOTE);
};

export const setCallbackQuote = ({ commit }) => {
  commit(types.SET_CALLBACK_QUOTE);
};

export const unsetCallbackQuote = ({ commit }) => {
  commit(types.UNSET_CALLBACK_QUOTE);
};

//export const setAcceptedQuote = ({commit}, value) => {
//	commit(types.SET_ACCEPTED_QUOTE, value)
//}

export const unsetAcceptedQuote = ({ commit }) => {
  commit(types.UNSET_ACCEPTED_QUOTE);
};

export const setQuoteStatus = ({ commit }, quotestatus) => {
  commit(types.SET_QUOTE_STATUS, quotestatus);
};

export const setSelectedCallCodeWizard = ({ commit }, callcode) => {
  commit(types.SET_SELECTED_CALL_CODE_WIZARD, callcode);
};

export const setSkipExitConfirmation = ({ commit }, skip) => {
  commit(types.SET_SKIP_EXIT_CONFIRMATION, skip);
};

export const loadComponentTypes = async ({ commit, dispatch, state }) => {
  try {
    var componentTypesPromise = null;
    // if(state.wizardData.vehicle.ComponentSetID === 0) {
    componentTypesPromise = apiVehicle.getActiveComponentTypes();
    // }
    // else {
    //   componentTypesPromise = apiVehicle.getSpecificComponentTypes(state.wizardData.vehicle.ComponentSetID);
    // }
    var response = await componentTypesPromise;
    commit(types.SET_COMPONENTS_FOR_VEHICLE, response.data);
  } catch (e) {
    var msg = 'There was an error loading the component types';
    dispatch('showError', msg, { root: true });
    throw msg;
  }
};

export const setPartsDisplay = async ({ commit, state }) => {
  var data = '';
  if (state.wizardData.vehicle.Components.length > 0) {
    let parts = state.wizardData.vehicle.Components;
    let missingParts = parts.filter((p) => {
      return p.isPresent === false;
    });

    let incompleteParts = parts.filter((p) => {
      return (
        (p.displayName === 'Catalytic converter' && p.isPresent === false) ||
        (p.makesVehicleIncomplete === true && p.isPresent === false)
      );
    });

    if (incompleteParts.length > 0) {
      data = 'Incomplete';
    }
    if (missingParts.length > 0 && incompleteParts.length == 0) {
      data = 'Complete - Some Parts Missing';
    }
    if (
      parts.length > 1 &&
      missingParts.length == 0 &&
      incompleteParts.length == 0
    ) {
      data = 'Complete - All Parts';
    }
  }
  commit(types.SET_PARTS_DISPLAY, data);
};

export const saveTermCode = async ({ dispatch }, saveTermCode) => {
  try {
    await wizardApi.saveTermCode(saveTermCode);
  } catch (e) {
    let msg = 'There was an error updating Term Code.';
    dispatch('showError', msg, { root: true });
    throw msg;
  }
};

export const getScreenPop = async ({ commit, dispatch }, livevoxSessionId) => {
  try {
    let response = await wizardApi.getScreenPop(livevoxSessionId);
    commit(types.SET_SCREEN_POP, response.data);
  } catch (e) {
    let msg = 'There was an error retrieving screen pop-up information.';
    dispatch('showError', msg, { root: true });
    throw msg;
  }
};

export const postManualCall = async ({ dispatch }, manualCall) => {
  try {
    await wizardApi.postManualCall(manualCall);
  } catch (e) {
    let msg = 'There was an error retrieving screen pop-up information.';
    dispatch('showError', msg, { root: true });
    throw msg;
  }
};

export const saveCallInfo = async ({ commit, dispatch }, callInfo) => {
  try {
    let response = await wizardApi.saveCallInfo(callInfo);
    let callInformation = {
      callInformationID: response.data,
      quoteID: callInfo.quoteID,
      callCodeID: callInfo.callCodeID,
      callerIDPhoneID: callInfo.callerIDPhoneID,
      callerIDName: callInfo.callerIDName,
    };
    commit(types.SET_CALL_INFORMATION, callInformation);
  } catch (e) {
    let msg = 'There was an error inserting call information.';
    dispatch('showError', msg, { root: true });
    throw msg;
  }
};

export const checkCallCodeID = async ({ dispatch, state }) => {
  if (
    state.wizardData.callInformation.CallCodeID == null ||
    state.wizardData.callInformation.CallCodeID === undefined
  ) {
    router.push('/dashboard');
    let msg =
      'No call code was found. Please select a call code from the list.';
    dispatch('showError', msg, { root: true });
  }
};

export const setVerintCallDisposition = async (
  { commit, dispatch },
  payload
) => {
  try {
    const { data } = await verintService.setVerintCallDisposition(payload);
    if (data.success == false) throw new Error(data.message);
    commit(types.SET_QUOTE_STATUS, payload.fields.quoteDisposition);
  } catch (e) {
    console.log('Error setting Verint call disposition:', e);
    const error = {
      title: 'Warning',
      message: 'Verint error, proceeding without setting call disposition.',
      type: 'warn',
    };
    commit(globalTypes.NOTIFY_ERRORS, error);
  }
};

// The follow-up to resolve at disposition when the quote was not opened from a follow-up link
export const setFollowupID = ({ state }, followupID) => {
  state.wizardData.followupID = followupID;
};

// Open a quote for an outbound call (single match, or picked from the open quotes step).
// Returns true once the wizard has been sent to it.
export const openQuote = async ({ commit, dispatch, state }, quoteID) => {
  try {
    // Load a quote as the dashboard follow-up link does. VoiceSessionID is
    // untouched by the quote load, so the end-of-call disposition still patches
    // the right interaction.
    await dispatch('getQuoteById', quoteID);
    if (state.wizardData.quote.QuoteID != quoteID) return false;

    // The search result has no follow-up ID; take the latest open follow-up from the loaded quote
    const openFollowupID = getOpenFollowupID(state.wizardData.followups, quoteID);

    try {
      await dispatch('saveCallInfo', {
        quoteID: quoteID,
        callCodeID: state.wizardData.mitelCallerID.callCodeID,
        callerIDPhoneID: state.wizardData.callInformation.CallerIDPhoneID,
        callerIDName: null,
        voiceSessionID: state.wizardData.callInformation.VoiceSessionID || null,
      });
    } catch (e) {
      // saveCallInfo has already shown the error; the quote still opens
    }

    const query = { quoteID: quoteID, followup: true };
    if (openFollowupID) query.followupid = openFollowupID;
    // The wizard's leave guard would otherwise ask to confirm leaving the loaded quote
    commit(types.SET_SKIP_EXIT_CONFIRMATION, true);
    // This wizard instance is reused for /quotes/update, so mounted() will not load the models
    if (state.wizardData.vehicle.MakeID > 0) dispatch('loadModels', state.wizardData.vehicle.MakeID);
    state.wizardData.openQuotes = [];
    // Wait for the navigation so the caller's loading overlay covers it
    // (vue-router 2 replace() returns no promise; it takes completion callbacks)
    await new Promise((resolve) =>
      router.replace({ path: '/quotes/update', query: query }, resolve, resolve)
    );
    return true;
  } catch (e) {
    return false;
  }
};

// Outbound call: look up open quotes for the seller's number (set from the DNIS)
// and pick up where the agent left off. Returns 'opened' when a single quote was
// loaded and the wizard was sent to it, otherwise 'none' or 'multiple' (the wizard
// stays on the create step, with the matches in wizardData.openQuotes for the open quotes step).
export const openQuoteForOutboundCall = async ({ dispatch, state }) => {
  // Never let a lookup failure block the call or the rest of the wizard setup
  try {
    const phoneNumber = state.wizardData.callInformation.CallerIDPhoneID;
    if (!phoneNumber) return 'none';

    let matches = [];
    try {
      const data = (await quoteApi.searchQuotesByPhoneNumber(phoneNumber)).data;
      matches = Array.isArray(data) ? data : [];
    } catch (e) {
      dispatch('showError', 'There was an error searching for open quotes.', {
        root: true,
      });
      return 'none';
    }

    if (matches.length === 0) {
      dispatch(
        'showNotification',
        {
          title: 'Open Quote',
          message: `No open quote was found for phone number ${phoneNumber}`,
          type: 'info',
        },
        { root: true }
      );
      return 'none';
    }

    if (matches.length > 1) {
      // The open quotes step (shown before step 1) lists wizardData.openQuotes
      state.wizardData.openQuotes = matches;
      return 'multiple';
    }

    return (await dispatch('openQuote', matches[0].quoteID)) ? 'opened' : 'none';
  } catch (e) {
    return 'none';
  }
};

// The seller's number is the ANI on an inbound call and the DNIS on an
// outbound call (the ANI is then our own line).
export const GetVerintInteraction = async (
  { state },
  { outbound, ...payload }
) => {
  const response = await verintService.GetVerintInteraction(payload);
  if (response.data.success) {
    const {
      data: {
        interaction: { interactions },
      },
    } = response;
    const sellerNumber = interactions
      ? outbound
        ? interactions[0].dnis
        : interactions[0].ani
      : null;
    // Save the Verint interaction ID (its primary key) for both directions; it is what
    // joins CallInformation to Verint data, and what the dispositions that follow patch.
    // A string, because the service binds it to a string property.
    if (interactions && interactions[0] && interactions[0].id != null) {
      state.wizardData.callInformation.VoiceSessionID = String(
        interactions[0].id
      );
    }
    // CallerIDPhoneID is varchar(10); an outbound DNIS may carry a country code
    state.wizardData.callInformation.CallerIDPhoneID = sellerNumber
      ? outbound
        ? sellerNumber.replace(/\D/g, '').slice(-10)
        : sellerNumber.replaceAll('+', '')
      : null;
  }
};

// Call code DNIS values are stored inconsistently (701-505-4469, 7015054469).
// Verint sends digits only, sometimes with a country code, so compare on the
// last 10 digits of each.
const normalizeDnis = (value) => {
  const digits = String(value == null ? '' : value).replace(/\D/g, '');
  return digits.length > 10 ? digits.slice(-10) : digits;
};

// Generic inbound bucket used when the DNIS does not resolve to a call code.
// Carbuy.CallInformation.CallCodeID is NOT NULL, so the quote still needs a
// value - it just must not be a real marketing code.
const UNRESOLVED_CALL_CODE_ID = 0;

export const initializeVerintCallInformation = async (
  { commit, dispatch, state, rootState },
  { externalId, dnis, outbound, isInteractionId }
) => {
  // VoiceSessionID holds the Verint interaction ID. An outbound link already carries it
  // (isInteractionId); otherwise externalId is the callid, and the interaction ID is
  // only known once GetVerintInteraction has found the interaction.
  state.wizardData.callInformation.VoiceSessionID = isInteractionId
    ? String(externalId)
    : null;

  if (outbound) {
    // On an outbound call the DNIS is the seller, so there is no call code to
    // match. Use the configured outbound call code (a string from config).
    const outboundCallCodeID = Number(config.outbound_call_code_id) || 0;
    state.wizardData.callInformation.CallCodeID = outboundCallCodeID;
    state.wizardData.mitelCallerID.callCodeID = outboundCallCodeID;
    // An outbound link with no callid only carries the Verint interaction ID
    // (OutboundTelephonyId); one with a real callid (third party) has the externalId
    try {
      await dispatch('GetVerintInteraction', {
        ...(isInteractionId ? { interactionId: externalId } : { externalId }),
        outbound: true,
      });
    } catch (e) {
      // fall through to the dnis from the link below
    }
    // The lookup can fail; the seller's number is also on the link as the dnis
    if (!state.wizardData.callInformation.CallerIDPhoneID) {
      const linkNumber = normalizeDnis(dnis);
      state.wizardData.callInformation.CallerIDPhoneID = linkNumber || null;
    }
    state.wizardData.mitelCallerID.callerNumber =
      state.wizardData.callInformation.CallerIDPhoneID || null;
    dispatch('setVerintCallDisposition', {
      interactionId: state.wizardData.callInformation.VoiceSessionID,
      fields: {
        quoteDisposition: 'Quote Started',
        quoteID: state.wizardData.quote.QuoteID,
      },
    });
    return;
  }

  // The wizard can be opened directly from the Verint CA iFrame without the
  // dashboard ever mounting, so the call code list may not be loaded yet.
  if (
    !rootState.callcodes ||
    !rootState.callcodes.call_codes ||
    rootState.callcodes.call_codes.length === 0
  ) {
    await dispatch('getAllCodes');
  }

  // Match call code by DNIS and set it in the wizard
  const callCodes =
    (rootState.callcodes && rootState.callcodes.call_codes) || [];
  const targetDnis = normalizeDnis(dnis);
  const matchedCode = targetDnis
    ? callCodes.find(
        (code) =>
          code.active &&
          code.name &&
          code.name.trim() !== '' &&
          normalizeDnis(code.dnis) === targetDnis
      )
    : undefined;
  if (matchedCode) {
    state.wizardData.callInformation.CallCodeID = matchedCode.id;
    state.wizardData.mitelCallerID.callCodeID = matchedCode.id;
    state.wizardData.mitelCallerID.callCodeName = matchedCode.name;
  } else {
    // Warn and keep going - the agent is on a live call and has no way back to
    // the dashboard from the Verint iFrame. Never fall through to the seed
    // default of 1, which would silently attribute the quote to a real
    // marketing code.
    const fallbackCode = callCodes.find(
      (code) => code.id === UNRESOLVED_CALL_CODE_ID
    );
    state.wizardData.callInformation.CallCodeID = UNRESOLVED_CALL_CODE_ID;
    state.wizardData.mitelCallerID.callCodeID = UNRESOLVED_CALL_CODE_ID;
    state.wizardData.mitelCallerID.callCodeName = fallbackCode
      ? fallbackCode.name
      : 'Unknown Call Code';
    commit(globalTypes.NOTIFY_ERRORS, {
      title: 'Warning',
      message:
        'No call code matched this call. Proceeding without call code attribution.',
      type: 'warn',
    });
  }
  
    // Fetch Verint interaction and extract caller ANI
  await dispatch('GetVerintInteraction', { externalId });

  // Set caller number from the ANI (inbound); outbound sets it from the DNIS above
  state.wizardData.mitelCallerID.callerNumber =
    state.wizardData.callInformation.CallerIDPhoneID || null;

  // Mark call as started in Verint
  dispatch('setVerintCallDisposition', {
    interactionId: state.wizardData.callInformation.VoiceSessionID,
    fields: {
      quoteDisposition: 'Quote Started',
      quoteID: state.wizardData.quote.QuoteID,
    },
  });
};



// WEBPACK FOOTER //
// ./src/store/modules/wizard/actions.js